import script from "./PatientCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientCards.vue?vue&type=script&setup=true&lang=ts"

import "./PatientCards.vue?vue&type=style&index=0&id=1de74ca4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de74ca4"]])

export default __exports__